import {PaymentElement} from '@stripe/react-stripe-js';
import {getPaymentElementTerms} from '@wc-stripe/blocks-utils';
import {useProcessCheckoutError, useProcessCheckoutSuccess, useCreatePaymentMethod} from "../hooks";

export const CardPaymentElement = (props) => {
    const {data} = props;
    const gatewayId = data.gatewayId;
    const shouldCreatePaymentMethod = !data.installmentsActive;
    const {
        billing: {billingAddress},
        eventRegistration,
        emitResponse,
        shouldSavePayment,
        activePaymentMethod
    } = props;
    const {
        email,
        phone,
        first_name,
        last_name
    } = billingAddress;
    const {
        onCheckoutSuccess,
        onCheckoutFail
    } = eventRegistration;

    const name = data.name;

    const {clearPaymentMethodData} = useCreatePaymentMethod({
        name,
        gatewayId,
        emitResponse,
        billingAddress,
        shouldSavePayment,
        eventRegistration,
        activePaymentMethod,
        shouldCreatePaymentMethod
    });

    useProcessCheckoutSuccess({
        name,
        emitResponse,
        billingAddress,
        onCheckoutSuccess,
        activePaymentMethod
    });

    useProcessCheckoutError({
        emitResponse,
        subscriber: onCheckoutFail,
        messageContext: emitResponse.noticeContexts.PAYMENTS,
        clearPaymentMethodData
    });

    const elementOptions = {
        defaultValues: {
            billingDetails: {
                name: `${first_name} ${last_name}`,
                email,
                phone
            }
        },
        fields: {
            billingDetails: {
                address: 'never',
                name: 'never',
                email: 'never',
                phone: !!phone ? 'never' : 'auto'
            }
        },
        wallets: {
            applePay: 'never',
            googlePay: 'never',
            link: data.elementOptions.paymentMethodTypes.includes('link') ? 'auto' : 'never'
        },
        terms: getPaymentElementTerms(data.termsDisplayRule),
        ...data.paymentElementOptions
    }
    return (
        <>
            <PaymentElement options={elementOptions}/>
        </>
    )
}

export default CardPaymentElement;